import { render, staticRenderFns } from "./PackageManagement.vue?vue&type=template&id=2b24509c&scoped=true"
import script from "./PackageManagement.vue?vue&type=script&lang=js"
export * from "./PackageManagement.vue?vue&type=script&lang=js"
import style0 from "./PackageManagement.vue?vue&type=style&index=0&id=2b24509c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24509c",
  null
  
)

export default component.exports